import {IComponentOptions, ILogService, IRootScopeService} from 'angular';
import {IStateService} from 'angular-ui-router';
import AuthServiceRS from '../../authentication/service/AuthServiceRS.rest';
import {TSAuthEvent} from '../../models/enums/TSAuthEvent';
import TSUser from '../../models/TSUser';
import RoleUtilService from '../service/RoleUtilService';
import ITranslateService = angular.translate.ITranslateService;

let template = require('./menubar.html');
require('./menubar.scss');

export class MenubarComponentConfig implements IComponentOptions {
    transclude = false;

    template = template;
    controller = MenuBarController;
    controllerAs = 'vm';
}

export class MenuBarController {

    static $inject = ['AuthServiceRS', '$log', '$rootScope', '$state', 'RoleUtilService', '$translate'];

    displayName?: string;
    isNavOpen: boolean = false;

    constructor(private authServiceRS: AuthServiceRS, private $log: ILogService, private $rootScope: IRootScopeService,
                private $state: IStateService, private roleUtilService: RoleUtilService,
                private $translate: ITranslateService,
    ) {
    }

    $onInit() {

        this.$rootScope.$on(TSAuthEvent[TSAuthEvent.LOGIN_SUCCESS], () => {
            this.displayName = this.getCurrentUserName();
        });
        this.$rootScope.$on(TSAuthEvent[TSAuthEvent.LOGOUT_SUCCESS], () => {
            this.displayName = undefined;
        });
    }

    public logout(): void {
        this.authServiceRS.logoutRequest().then(() => {
            this.$log.debug('logout successfull');
            this.$state.go('start');  // going back to start should show us the login form
        });
    }

    public isLoggedIn(): boolean {
        if (this.$state.current.name === 'login'
            || this.$state.current.name === 'loginanlaufstelle'
            || this.$state.current.name === 'locallogin'
        ) {
            return false;
        }

        return this.authServiceRS.getPrincipal() !== undefined && this.authServiceRS.getPrincipal() !== null;
    }

    public getCurrentUserName(): string | undefined {
        let principal: TSUser | undefined = this.authServiceRS.getPrincipal();
        if (principal) {
            return principal.getFullName();
        }
        return undefined;
    }

    public changeLang(langstring: string) {
        this.$translate.use(langstring);
    }

    public getCurrentLang(): string {
        return this.$translate.use();
    }

    public isLangActive(lang: string): boolean {
        return this.getCurrentLang() === lang;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/toolbar/menubar.ts